module.exports = __webpack_public_path__ + "static/media/riot-on-an-empty-street.9b48d0de.jpg";